var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstantBet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#E3CDFF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2852_4920",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.22435 15.1417C9.08268 15.1417 8.94935 15.1167 8.80768 15.0667C8.34935 14.8917 8.04935 14.4667 8.04935 13.9751V11.2251H7.23268C6.76602 11.2251 6.35768 10.9584 6.16602 10.5417C5.97435 10.1167 6.04935 9.64175 6.35768 9.29175L9.90768 5.25841C10.2327 4.89175 10.7327 4.76675 11.191 4.94175C11.6493 5.11675 11.9493 5.54175 11.9493 6.03341V8.78341H12.7743C13.241 8.78341 13.6493 9.05008 13.841 9.46675C14.0327 9.89175 13.9577 10.3667 13.6493 10.7167L10.0993 14.7501C9.86602 15.0001 9.54935 15.1417 9.22435 15.1417ZM7.41602 9.97508H8.67435C9.01602 9.97508 9.29935 10.2584 9.29935 10.6001V13.7501L12.5827 10.0251H11.3243C10.9827 10.0251 10.6993 9.74175 10.6993 9.40008V6.25008L7.41602 9.97508Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9577 10.0001C18.9577 14.9476 14.9469 18.9584 9.99935 18.9584C5.0518 18.9584 1.04102 14.9476 1.04102 10.0001C1.04102 5.05253 5.0518 1.04175 9.99935 1.04175C14.9469 1.04175 18.9577 5.05253 18.9577 10.0001ZM2.47435 10.0001C2.47435 14.156 5.84341 17.5251 9.99935 17.5251C14.1553 17.5251 17.5243 14.156 17.5243 10.0001C17.5243 5.84414 14.1553 2.47508 9.99935 2.47508C5.84341 2.47508 2.47435 5.84414 2.47435 10.0001Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2852_4920)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "inherit"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstantBet);
export default __webpack_public_path__ + "static/media/instant-bet.7f2a50b0890aafa860bbe43a3126234f.svg";
export { ForwardRef as ReactComponent };